export default "__VITE_ASSET__D95nMmAV__"